<template>
  <div class="wework-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" class="wework-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运维管理</el-breadcrumb-item>
      <el-breadcrumb-item>外卖平台</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主体布局：左侧内容 + 右侧栏 -->
    <div class="wework-layout">
      <!-- 左侧主内容区 -->
      <div class="wework-main">
        <el-card class="wework-card wework-card-tabs" shadow="hover">
          <el-tabs v-model="activeTab" class="wework-tabs" @tab-click="handleTabChange">
            <!-- Tab: 数据采集 -->
            <el-tab-pane name="collect">
              <span slot="label">
                <i class="el-icon-download"></i> 大盘数据采集
              </span>
              <div class="tab-toolbar">
                <el-select v-model="selectedBrand" placeholder="选择品牌" size="small" style="width: 140px;" @change="onBrandChange">
                  <el-option v-for="item in brandList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select v-model="collectForm.platform" placeholder="选择平台" size="small" style="width: 140px;" @change="handleCollectPlatformChange">
                  <el-option v-for="p in platformOptions" :key="p.value" :label="p.label" :value="p.value"></el-option>
                </el-select>
                <el-select v-model="collectForm.collectType" placeholder="采集类型" size="small" style="width: 120px;" :disabled="!collectForm.platform" @change="handleCollectTypeChange">
                  <el-option v-for="t in collectTypeOptions" :key="t.value" :label="t.label" :value="t.value"></el-option>
                </el-select>
                <el-date-picker v-model="collectForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" size="small" style="width: 260px;" value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions">
                </el-date-picker>
                <el-button type="primary" size="small" icon="el-icon-download" @click="startCollect"
                  :loading="collectLoading" :disabled="!collectForm.platform || !collectForm.dateRange">
                  开始采集
                </el-button>
              </div>
              <el-table :data="logList" border stripe size="small" style="width: 100%" v-loading="logLoading"
                :height="tableHeight" class="wework-table">
                <el-table-column prop="collectAt" label="采集时间" width="160" align="center">
                  <template slot-scope="scope">{{ $getDateTime(scope.row.collectAt) }}</template>
                </el-table-column>
                <el-table-column label="平台" width="100" align="center">
                  <template slot-scope="scope">
                    <el-tag size="mini">{{ platformLabel(scope.row.platform) }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="日期范围" width="200" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.params ? scope.row.params.startDate : '' }} ~ {{ scope.row.params ? scope.row.params.endDate : '' }}
                  </template>
                </el-table-column>
                <el-table-column prop="collectBy" label="操作人" width="100" align="center"></el-table-column>
                <el-table-column label="状态" width="90" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'danger' : 'warning'" size="mini">
                      {{ scope.row.status === 1 ? '成功' : scope.row.status === 2 ? '失败' : '采集中' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="errorMessage" label="错误信息" min-width="200" show-overflow-tooltip></el-table-column>
              </el-table>
              <el-pagination @current-change="handleLogPageChange" :current-page="logPagenum" :page-size="logPagesize"
                :total="logTotal" layout="total, prev, pager, next" class="wework-pagination">
              </el-pagination>
            </el-tab-pane>

            <!-- Tab: 美团评论采集 -->
            <el-tab-pane name="comment">
              <span slot="label">
                <i class="el-icon-chat-line-square"></i> 美团评论采集
              </span>
              <div class="tab-toolbar">
                <el-select v-model="selectedBrand" placeholder="选择品牌" size="small" style="width: 140px;" @change="onBrandChange">
                  <el-option v-for="item in brandList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-tag size="small" type="warning">美团</el-tag>
                <el-date-picker v-model="commentForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" size="small" style="width: 260px;" value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions">
                </el-date-picker>
                <el-button type="primary" size="small" icon="el-icon-chat-line-square" @click="startCollectComment"
                  :loading="commentCollectLoading" :disabled="!commentForm.dateRange || commentForm.dateRange.length !== 2">
                  开始采集评论
                </el-button>
              </div>
              <el-table :data="commentLogList" border stripe size="small" style="width: 100%" v-loading="commentLogLoading"
                :height="tableHeight" class="wework-table">
                <el-table-column prop="collectAt" label="采集时间" width="160" align="center">
                  <template slot-scope="scope">{{ $getDateTime(scope.row.collectAt) }}</template>
                </el-table-column>
                <el-table-column label="平台" width="100" align="center">
                  <template slot-scope="scope">
                    <el-tag size="mini">{{ platformLabel(scope.row.platform) }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="日期范围" width="200" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.params ? scope.row.params.startDate : '' }} ~ {{ scope.row.params ? scope.row.params.endDate : '' }}
                  </template>
                </el-table-column>
                <el-table-column prop="collectBy" label="操作人" width="100" align="center"></el-table-column>
                <el-table-column label="状态" width="90" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'danger' : 'warning'" size="mini">
                      {{ scope.row.status === 1 ? '成功' : scope.row.status === 2 ? '失败' : '采集中' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="errorMessage" label="错误信息" min-width="200" show-overflow-tooltip></el-table-column>
              </el-table>
              <el-pagination @current-change="handleCommentLogPageChange" :current-page="commentLogPagenum" :page-size="commentLogPagesize"
                :total="commentLogTotal" layout="total, prev, pager, next" class="wework-pagination">
              </el-pagination>
            </el-tab-pane>

          </el-tabs>
        </el-card>
      </div>

      <!-- 右侧栏 -->
      <div class="wework-sidebar">
        <!-- 采集端配置提示 -->
        <el-card class="wework-card sidebar-card" shadow="hover">
          <div style="font-size:13px;color:#909399;line-height:1.8;">
            <i class="el-icon-info" style="color:#409eff;margin-right:4px;"></i>
            采集端配置请前往
            <el-link type="primary" href="#/yunwei/collector">采集端管理</el-link>
          </div>
        </el-card>

        <!-- 浏览器 CDP 诊断 -->
        <el-card class="wework-card sidebar-card" shadow="hover">
          <div slot="header" class="sidebar-card-header">
            <i class="el-icon-monitor"></i>
            <span>CDP 诊断</span>
            <el-button type="text" style="margin-left: auto; padding: 0;" @click="diagnoseAll" :loading="cdpAllLoading" size="mini">全部诊断</el-button>
          </div>
          <!-- 端口列表为空（未加载或无配置） -->
          <div v-if="cdpCards.length === 0" class="account-info" style="color: #999; text-align: center; padding: 12px 0;">
            {{ cdpCardsLoading ? '加载中...' : '暂无 CDP 端口配置' }}
          </div>
          <!-- 每个端口一张卡片，各自诊断 -->
          <div v-for="card in cdpCards" :key="card.collectorId + '_' + card.port" class="cdp-endpoint-block">
            <div class="cdp-endpoint-header">
              <el-tag v-if="card.result" :type="statusTagType(card.result.status)" size="mini">
                {{ statusLabel(card.result.status) }}
              </el-tag>
              <el-tag v-else type="info" size="mini">未诊断</el-tag>
              <span class="cdp-port">:{{ card.port }}</span>
              <el-button type="text" style="margin-left: auto; padding: 0;" @click="diagnoseCard(card)" :loading="card.loading" size="mini">诊断</el-button>
            </div>

            <!-- 服务器（采集端实例名 + 地址） -->
            <div class="cdp-server-row" v-if="card.serverName || card.serverUrl">
              <i class="el-icon-cpu"></i>
              <span v-if="card.serverName">{{ card.serverName }}</span>
              <span v-if="card.serverName && card.serverUrl" style="color: #c0c4cc;"> · </span>
              <span v-if="card.serverUrl">{{ card.serverUrl }}</span>
            </div>

            <!-- 品牌（共用端口的多个品牌全列出） -->
            <div class="cdp-brands-row">
              {{ card.brands.join(' / ') }}
            </div>

            <!-- 未诊断提示 -->
            <div v-if="!card.result" class="cdp-status-reason" style="color: #909399;">
              点击「诊断」检测该端口浏览器状态
            </div>
            <!-- 结论行 -->
            <div v-else class="cdp-status-reason" :style="{ color: statusColor(card.result.status) }">
              {{ card.result.statusReason }}
            </div>

            <!-- 在线时展示明细 -->
            <div v-if="card.result && card.result.reachable" class="cdp-endpoint-detail">
              <div class="cdp-detail-row">
                <span class="cdp-detail-label">版本</span>
                <span class="cdp-detail-value">{{ card.result.browser }}</span>
              </div>
              <div class="cdp-detail-row">
                <span class="cdp-detail-label">标签页</span>
                <span class="cdp-detail-value">{{ card.result.tabCount }} 个</span>
              </div>
              <div class="cdp-detail-row">
                <span class="cdp-detail-label">平台</span>
                <span class="cdp-detail-value">
                  <el-tag v-if="card.result.platforms.meituan" type="success" size="mini">美团</el-tag>
                  <el-tag v-if="card.result.platforms.jd" type="success" size="mini" style="margin-left: 4px;">京东</el-tag>
                  <el-tag v-if="card.result.platforms.taobao" type="success" size="mini" style="margin-left: 4px;">淘宝</el-tag>
                </span>
              </div>
              <div class="cdp-detail-row">
                <span class="cdp-detail-label">耗时</span>
                <span class="cdp-detail-value">{{ card.result.latencyMs }}ms</span>
              </div>
            </div>

            <div v-if="card.result" class="cdp-checked-time">诊断时间: {{ formatCdpTime(card.result.checkedAt) }}</div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { brandList } from '@/utility/staticData'

export default {
  data () {
    return {
      activeTab: 'collect',

      // 品牌列表
      brandList,
      selectedBrand: brandList[0] || '',

      // 采集表单
      collectForm: {
        platform: '',
        collectType: '外卖',
        dateRange: null
      },
      collectLoading: false,

      // 平台选项
      platformOptions: [
        { label: '美团', value: 'meituan' },
        { label: '京东', value: 'jd' },
        { label: '淘宝闪购', value: 'taobao' }
      ],

      // 日期快捷选项
      pickerOptions: {
        disabledDate (time) {
          const yesterday = new Date()
          yesterday.setDate(yesterday.getDate() - 1)
          yesterday.setHours(23, 59, 59, 999)
          return time.getTime() > yesterday.getTime()
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, start])
          }
        }, {
          text: '最近7天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近30天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },

      // 日志列表
      logList: [],
      logTotal: 0,
      logPagenum: 1,
      logPagesize: 20,
      logLoading: false,
      logFilter: {
        platform: '',
        status: ''
      },

      // CDP 诊断：每端口一张卡片，各自诊断
      cdpCards: [], // [{ port, brands, result, loading }]
      cdpCardsLoading: false, // 加载端口列表
      cdpAllLoading: false, // 全部诊断

      // 轮询定时器
      pollingTimer: null,

      // ========== 评论采集相关 ==========
      commentForm: { dateRange: null },
      commentCollectLoading: false,
      commentLogList: [],
      commentLogTotal: 0,
      commentLogPagenum: 1,
      commentLogPagesize: 20,
      commentLogLoading: false

    }
  },
  computed: {
    tableHeight () {
      return window.innerHeight - 280
    },
    hasCollecting () {
      if (this.activeTab === 'comment') {
        return this.commentLogList.some(item => item.status === 0)
      }
      return this.logList.some(item => item.status === 0)
    },
    collectTypeOptions () {
      const map = {
        meituan: [{ label: '外卖', value: '外卖' }, { label: '拼好饭', value: '拼好饭' }],
        taobao: [{ label: '外卖', value: '外卖' }, { label: '爆品团', value: '爆品团' }],
        jd: [{ label: '外卖', value: '外卖' }]
      }
      return map[this.collectForm.platform] || [{ label: '外卖', value: '外卖' }]
    }
  },
  created () {
    this.loadLogs()
    this.loadCommentLogs()
    this.fetchCdpEndpoints()
    // 从数据监控页跳转过来时，预填平台和日期
    if (this.$route.query.date) {
      this.collectForm.dateRange = [this.$route.query.date, this.$route.query.date]
    }
    if (this.$route.query.platform) {
      this.collectForm.platform = this.$route.query.platform
    }
  },
  beforeDestroy () {
    this.stopPolling()
  },
  methods: {
    // 平台名称映射
    platformLabel (value) {
      const map = { meituan: '美团', jd: '京东', taobao: '淘宝闪购' }
      return map[value] || value
    },

    // 切换品牌：重置分页并重载两个日志列表（日志按品牌过滤）
    onBrandChange () {
      this.logPagenum = 1
      this.commentLogPagenum = 1
      this.loadLogs()
      this.loadCommentLogs()
    },

    // 加载 CDP 端口列表（渲染空卡片，不探活）
    async fetchCdpEndpoints () {
      this.cdpCardsLoading = true
      try {
        const { data: res } = await this.$http.get('yunwei/wework/cdpEndpoints')
        if (res.meta.status === 200) {
          // 端口列表 → 空卡片（保留已有诊断结果，避免刷新端口列表时丢失）
          // key 用 collectorId + port 组合（跨服务器可能有相同端口）
          const oldMap = new Map(this.cdpCards.map(c => [c.collectorId + '_' + c.port, c]))
          this.cdpCards = (res.data.list || []).map(item => ({
            collectorId: item.collectorId,
            port: item.port,
            brands: item.brands || [],
            serverName: item.serverName || '',
            serverUrl: item.serverUrl || '',
            result: oldMap.get(item.collectorId + '_' + item.port)?.result || null,
            loading: false
          }))
        }
      } catch (e) { /* 忽略，端口列表失败不阻塞页面 */ }
      this.cdpCardsLoading = false
    },

    // 诊断单个端口卡片
    async diagnoseCard (card) {
      card.loading = true
      try {
        // collectorId 定位服务器，port 定位该服务器的端口
        const { data: res } = await this.$http.get('yunwei/wework/cdpStatus', { params: { collectorId: card.collectorId, port: card.port } })
        if (res.meta.status === 200) {
          // 单端口诊断返回 endpoints 数组，取第一个
          const ep = res.data.endpoints && res.data.endpoints[0]
          if (ep) {
            card.result = ep
          } else {
            this.$message.warning(`端口 ${card.port} 未在采集端配置中找到`)
          }
        } else {
          this.$message.error(res.meta.msg || `端口 ${card.port} 诊断失败`)
        }
      } catch (e) {
        this.$message.error(`端口 ${card.port} 诊断请求失败`)
      }
      card.loading = false
    },

    // 全部诊断
    async diagnoseAll () {
      this.cdpAllLoading = true
      // 并行诊断所有卡片
      await Promise.all(this.cdpCards.map(card => this.diagnoseCard(card)))
      this.cdpAllLoading = false
      const okCount = this.cdpCards.filter(c => c.result && c.result.status === 'ok').length
      const total = this.cdpCards.length
      if (okCount === total) {
        this.$message.success(`全部 ${total} 个端口正常`)
      } else {
        this.$message.warning(`${okCount}/${total} 个端口正常`)
      }
    },

    // CDP 状态文案 / Tag 类型 / 颜色
    statusLabel (status) {
      const map = { ok: '正常', warning: '异常', offline: '离线' }
      return map[status] || status
    },
    statusTagType (status) {
      const map = { ok: 'success', warning: 'warning', offline: 'danger' }
      return map[status] || 'info'
    },
    statusColor (status) {
      const map = { ok: '#67c23a', warning: '#e6a23c', offline: '#f56c6c' }
      return map[status] || '#909399'
    },

    // 格式化诊断时间
    formatCdpTime (isoStr) {
      if (!isoStr) return '-'
      const d = new Date(isoStr)
      const pad = n => String(n).padStart(2, '0')
      return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },

    // 开始采集
    async startCollect () {
      if (!this.selectedBrand) {
        return this.$message.warning('请选择品牌')
      }
      if (!this.collectForm.platform) {
        return this.$message.warning('请选择平台')
      }
      if (!this.collectForm.dateRange || this.collectForm.dateRange.length !== 2) {
        return this.$message.warning('请选择日期范围')
      }
      const typeLabel = this.collectForm.collectType !== '外卖' ? this.collectForm.collectType : ''
      this.$confirm(
        `确认采集「${this.platformLabel(this.collectForm.platform)}」平台${typeLabel} ${this.collectForm.dateRange[0]} ~ ${this.collectForm.dateRange[1]} 的数据？`,
        '采集确认',
        { confirmButtonText: '确认', cancelButtonText: '取消', type: 'info' }
      ).then(() => {
        this.doCollect()
      }).catch(() => {})
    },

    // 执行采集
    async doCollect () {
      this.collectLoading = true
      try {
        const params = {
          brand: this.selectedBrand,
          platform: this.collectForm.platform,
          type: this.collectForm.collectType || '外卖',
          startDate: this.collectForm.dateRange[0],
          endDate: this.collectForm.dateRange[1]
        }
        const { data: res } = await this.$http.post('yunwei/waimai/start', params)
        if (res.meta.status === 200) {
          this.$message.success('采集任务已创建')
          this.logPagenum = 1
          this.loadLogs()
          this.startPolling()
        } else {
          this.$message.error(res.meta.msg || '创建失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
      }
      this.collectLoading = false
    },

    // 加载日志列表
    async loadLogs () {
      this.logLoading = true
      try {
        const params = { pagenum: this.logPagenum, pagesize: this.logPagesize, type: this.collectForm.collectType || '外卖' }
        if (this.selectedBrand) params.brand = this.selectedBrand
        if (this.logFilter.platform) params.platform = this.logFilter.platform
        if (this.logFilter.status !== '' && this.logFilter.status !== null) params.status = this.logFilter.status
        const { data: res } = await this.$http.get('yunwei/waimai/logs', { params })
        if (res.meta.status === 200) {
          this.logList = res.data.list || []
          this.logTotal = res.data.total || 0
        }
        // 检查是否还有采集中记录
        if (!this.hasCollecting) {
          this.stopPolling()
        }
      } catch (e) { /* 忽略 */ }
      this.logLoading = false
    },

    handleLogPageChange (val) {
      this.logPagenum = val
      this.loadLogs()
    },

    // ========== 美团评论采集 ==========

    // 开始评论采集
    startCollectComment () {
      if (!this.selectedBrand) {
        return this.$message.warning('请选择品牌')
      }
      if (!this.commentForm.dateRange || this.commentForm.dateRange.length !== 2) {
        return this.$message.warning('请选择日期范围')
      }
      this.$confirm(
        `确认采集美团 ${this.commentForm.dateRange[0]} ~ ${this.commentForm.dateRange[1]} 的评论？`,
        '采集确认',
        { confirmButtonText: '确认', cancelButtonText: '取消', type: 'info' }
      ).then(() => {
        this.doCollectComment()
      }).catch(() => {})
    },

    // 执行评论采集
    async doCollectComment () {
      this.commentCollectLoading = true
      try {
        const params = {
          brand: this.selectedBrand,
          platform: 'meituan',
          type: '评论',
          startDate: this.commentForm.dateRange[0],
          endDate: this.commentForm.dateRange[1]
        }
        const { data: res } = await this.$http.post('yunwei/waimai/start', params)
        if (res.meta.status === 200) {
          this.$message.success('采集任务已创建')
          this.commentLogPagenum = 1
          this.loadCommentLogs()
          this.startPolling()
        } else {
          this.$message.error(res.meta.msg || '创建失败')
        }
      } catch (e) {
        this.$message.error('请求失败')
      }
      this.commentCollectLoading = false
    },

    // 加载评论日志列表
    async loadCommentLogs () {
      this.commentLogLoading = true
      try {
        const params = { pagenum: this.commentLogPagenum, pagesize: this.commentLogPagesize, type: '评论' }
        if (this.selectedBrand) params.brand = this.selectedBrand
        const { data: res } = await this.$http.get('yunwei/waimai/logs', { params })
        if (res.meta.status === 200) {
          this.commentLogList = res.data.list || []
          this.commentLogTotal = res.data.total || 0
        }
        if (!this.hasCollecting) {
          this.stopPolling()
        }
      } catch (e) { /* 忽略 */ }
      this.commentLogLoading = false
    },

    handleCommentLogPageChange (val) {
      this.commentLogPagenum = val
      this.loadCommentLogs()
    },

    // ========== 采集类型切换 ==========

    handleCollectPlatformChange () {
      const valid = this.collectTypeOptions.some(opt => opt.value === this.collectForm.collectType)
      if (!valid) {
        this.collectForm.collectType = '外卖'
      }
      this.logPagenum = 1
      this.loadLogs()
    },

    handleCollectTypeChange () {
      this.logPagenum = 1
      this.loadLogs()
    },

    // ========== Tab 切换 ==========

    handleTabChange (tab) {
      if (tab.name === 'comment') {
        this.loadCommentLogs()
      } else if (tab.name === 'collect') {
        this.loadLogs()
      }
    },

    // ========== 轮询 ==========

    // 轮询采集中状态
    startPolling () {
      this.stopPolling()
      this.pollingTimer = setInterval(() => {
        if (this.hasCollecting) {
          if (this.activeTab === 'comment') {
            this.loadCommentLogs()
          } else {
            this.loadLogs()
          }
        } else {
          this.stopPolling()
        }
      }, 10000)
    },

    stopPolling () {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    }

  }
}
</script>

<style scoped>
.wework-page {
  padding: 0 4px;
}

.wework-breadcrumb {
  margin-bottom: 16px;
}

/* ========== 主布局：左右分栏 ========== */
.wework-layout {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.wework-main {
  flex: 1;
  min-width: 0;
}

.wework-sidebar {
  width: 360px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ========== 卡片样式 ========== */
.wework-card {
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

.wework-card-tabs {
  min-height: calc(100vh - 180px);
}

.wework-card-tabs >>> .el-card__body {
  padding: 0 20px 20px;
}

/* ========== Tab 样式 ========== */
.wework-tabs >>> .el-tabs__header {
  margin-bottom: 0;
  padding-top: 4px;
}

.wework-tabs >>> .el-tabs__item {
  height: 46px;
  line-height: 46px;
  font-size: 14px;
  font-weight: 500;
}

.wework-tabs >>> .el-tabs__item i {
  margin-right: 4px;
}

.wework-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
}

/* ========== Tab 工具栏 ========== */
.tab-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 0 12px;
}

/* ========== 表格 ========== */
.wework-pagination {
  padding: 14px 0 0;
  text-align: right;
}

/* ========== 右侧栏卡片 ========== */
.sidebar-card {
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

.sidebar-card >>> .el-card__header {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f2f5;
  background: #fafbfc;
}

.sidebar-card >>> .el-card__body {
  padding: 16px;
}

.sidebar-card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.sidebar-card-header i {
  font-size: 16px;
  color: #409eff;
}

.sidebar-form >>> .el-form-item {
  margin-bottom: 12px;
}

.sidebar-form >>> .el-form-item__label {
  font-size: 13px;
  color: #606266;
}

.sidebar-actions {
  display: flex;
  gap: 8px;
  padding-top: 4px;
}

/* ========== 信息展示 ========== */
.account-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.account-field {
  display: flex;
  align-items: baseline;
  font-size: 13px;
  line-height: 1.5;
}

.account-field label {
  flex-shrink: 0;
  width: 56px;
  color: #909399;
  text-align: right;
  margin-right: 8px;
  font-weight: 500;
}

.account-field span {
  color: #303133;
  word-break: break-all;
}

/* ========== CDP 诊断 ========== */
.cdp-endpoint-block {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

.cdp-endpoint-block:last-of-type {
  border-bottom: none;
}

.cdp-endpoint-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.cdp-port {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

/* 服务器行：采集端实例名 + 完整地址，小字灰色 */
.cdp-server-row {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
  word-break: break-all;
}

.cdp-server-row i {
  margin-right: 4px;
}

/* 品牌行：共用端口的多个品牌全列出，加粗显眼 */
.cdp-brands-row {
  font-size: 13px;
  font-weight: 600;
  color: #409eff;
  margin-bottom: 4px;
  word-break: break-all;
}

/* 结论行：颜色跟随 status */
.cdp-status-reason {
  font-size: 12px;
  margin-bottom: 8px;
  line-height: 1.5;
}

.cdp-endpoint-detail {
  padding-left: 4px;
}

.cdp-detail-row {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1.8;
  color: #606266;
}

.cdp-detail-label {
  flex-shrink: 0;
  width: 42px;
  color: #909399;
  text-align: right;
  margin-right: 8px;
}

.cdp-detail-value {
  color: #303133;
}

.cdp-checked-time {
  font-size: 11px;
  color: #c0c4cc;
  text-align: right;
  margin-top: 8px;
}
</style>
